const getUrlParams = (key, locationSearch = null) => {
	const encodedKey = decodeURIComponent(key);
	const urlParams = new URLSearchParams(locationSearch ?? window.location.search);
	const queryString = urlParams.get(encodedKey);
	return queryString ? decodeURIComponent(queryString) : "";
};

export default getUrlParams;
